import { DateTransform } from '@ember-data/serializer/transform'
export default DateTransform
